import { render, staticRenderFns } from "./scoreboard_tennis.vue?vue&type=template&id=5e5adefa&scoped=true&"
import script from "./scoreboard_tennis.vue?vue&type=script&lang=js&"
export * from "./scoreboard_tennis.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_tennis.vue?vue&type=style&index=0&id=5e5adefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5adefa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventScoreboardSets: require('/var/web/bet777.es/components/event/scoreboard_sets.vue').default})
